export default __webpack_public_path__ + "static/media/020_start.first.fac3d0cb.png";